import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle } from 'lucide-react';

const ServicesPage = () => {
  const { serviceId } = useParams();

  const servicesData = {
    'aile-hukuku': {
      title: 'AİLE VE BOŞANMA HUKUKU',
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/s6t9buo8_aile%20hukuk.jpeg',
      description:
        'Aile hukuku, ailevi ilişkilerin düzenlenmesi ve bu ilişkilerden doğan uyuşmazlıkların çözümlenmesi ile ilgili hukuk dalıdır. Bu alanda sunduğumuz hizmetler:',
      services: [
        'Boşanma dava ve işlemleri',
        'Velayet ve çocuğun teslimi davaları',
        'Nafaka (iştirak, tazminat, yoksulluk) davaları',
        'Mal rejimi tasfiyesi',
        'Özel hukuk hukuki danışmanlık',
        'Evlilik sözleşmeleri',
        'Soybagı davaları',
      ],
    },
    'yabancilar-hukuku': {
      title: 'YABANCILAR HUKUKU',
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/7uqm6dj0_pasarport.jpeg',
      description:
        'Yabancıların Türkiye\'de kalma, çalışma ve vatandaşlık hakları ile ilgili hukuki süreçlerde profesyonel danışmanlık hizmeti sunuyoruz. Hizmetlerimiz:',
      services: [
        'İkamet izni başvuruları',
        'Çalışma izni işlemleri',
        'Vatandaşlık başvuruları',
        'Sınır dışı işlemlerine itiraz',
        'Uluslararası koruma başvuruları',
        'Evlilik yoluyla vatandaşlık',
        'Yabancıların çalışma hakları',
      ],
    },
    'ceza-hukuku': {
      title: 'CEZA HUKUKU',
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/8jplo9lt_kelepc%CC%A7le.jpeg',
      description:
        'Ceza hukuku, suç ve cezalarla ilgili hukuki süreçlerde müvekkillerimize kapsamlı savunma ve temsil hizmeti sunuyoruz:',
      services: [
        'Suç mağduru ve sanık müvekkil savunması',
        'Soruşturma ve kovuşturma aşamasında temsil',
        'Tutuklamaya itiraz',
        'Temyiz başvuruları',
        'Uzlaşma görüşmeleri',
        'Şikayetten vazgeçme işlemleri',
        'Adli kontrol tedbirlerine itiraz',
      ],
    },
    'sigorta-hukuku': {
      title: 'SİGORTA HUKUKU',
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/vv7bcg38_kaza%20car.jpeg',
      description:
        'Sigorta şirketleri ile olan uyuşmazlıklarda müvekkillerimizin haklarını koruyoruz. Hizmetlerimiz:',
      services: [
        'Trafik kazası tazminat davaları',
        'Ferdi kaza sigortaları',
        'Kasko uyuşmazlıkları',
        'Zorunlu deprem sigortaları',
        'Hayat sigortaları',
        'Sağlık sigortaları',
        'Sigorta sözleşme danışmanlığı',
      ],
    },
    'gayrimenkul-hukuku': {
      title: 'GAYRİMENKUL HUKUKU',
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/69umcahx_gayrimenkul.jpeg',
      description:
        'Gayrimenkul alım-satımı, kiralama ve tapu işlemleri gibi konularda profesyonel hukuki danışmanlık sunuyoruz:',
      services: [
        'Tapu iptali ve tescil davaları',
        'Gayrimenkul alım-satım sözleşmeleri',
        'Kira uyuşmazlıkları',
        'Tahliye davaları',
        'Kat mülkiyeti ve kat karşılığı inşaat sözleşmeleri',
        'İrtifak hakkı tesisi',
        'Gayrimenkul değer tespiti',
      ],
    },
    'yapay-zeka-hukuku': {
      title: 'YAPAY ZEKA VE BİLİŞİM HUKUKU',
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/2vd8o6t1_pexels-pixabay-270404.jpg',
      description:
        'Dijital dünyada ortaya çıkan hukuki sorunlarda modern çözümler sunuyoruz. Hizmetlerimiz:',
      services: [
        'Kişisel verilerin korunması (KVKK)',
        'E-ticaret hukuku',
        'Siber güvenlik ve veri ihlalleri',
        'Yapay zeka uygulamalarının hukuki yönleri',
        'Dijital içerik ve telif hakları',
        'Sosyal medya hukuku',
        'Bilişim suçları',
      ],
    },
    'is-hukuku': {
      title: 'İŞ HUKUKU',
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/x6u6xrsi_is%CC%A7%20hukuk.jpeg',
      description:
        'İşçi ve işveren arasındaki ilişkilerde hukuki danışmanlık ve dava takibi yapıyoruz:',
      services: [
        'İşe iade davaları',
        'Kıdem ve ihbar tazminatı davaları',
        'İş kazası ve meslek hastalığı tazminat davaları',
        'Mobbing (psikolojik taciz) davaları',
        'İş sözleşmesi hazırlanması',
        'Ücretsiz izin dönemleri',
        'Fazla mesai alacakları',
      ],
    },
    'ticaret-hukuku': {
      title: 'TİCARET HUKUKU',
      image: 'https://customer-assets.emergentagent.com/job_gur-legal/artifacts/ofi6vy4q_ticaret%20hukuku.jpeg',
      description:
        'Ticari işletmelerin hukuki ihtiyaçlarında profesyonel danışmanlık ve temsil hizmeti sunuyoruz:',
      services: [
        'Şirket kuruluşu ve şirket türü değişikliği',
        'Ticari sözleşmelerin hazırlanması',
        'Ortaklık uyuşmazlıkları',
        'Alacak ve tahliye davaları',
        'Çek, senet ve bonoya dayalı takipler',
        'Rekabet hukuku',
        'Franchise sözleşmeleri',
      ],
    },
  };

  const service = servicesData[serviceId];

  if (!service) {
    return (
      <div 
        className="min-h-screen relative"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_avukat-portal-6/artifacts/rf25a184_indir.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Navbar />
        <div className="pt-32 pb-20 text-center">
          <div className="backdrop-blur-md bg-black/60 p-12 rounded-lg inline-block">
            <h1 className="text-3xl font-bold text-white">Hizmet bulunamadı</h1>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen relative"
      style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_avukat-portal-6/artifacts/rf25a184_indir.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      
      <Navbar />

      {/* Hero Section with black semi-transparent blur background */}
      <section className="relative h-96 flex items-center justify-center pt-20">
        <div className="backdrop-blur-md bg-black/60 px-12 py-8 rounded-lg">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
              {service.title}
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section with black semi-transparent blur background */}
      <section className="relative py-20">
        <div className="max-w-5xl mx-auto px-6">
          <Card className="bg-black/60 backdrop-blur-md border-white/20">
            <CardContent className="p-8">
              <p className="text-white text-lg leading-relaxed mb-8" style={{ fontFamily: 'Georgia, serif' }}>
                {service.description}
              </p>

              <div className="space-y-4">
                {service.services.map((item, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-white flex-shrink-0 mt-0.5" />
                    <span className="text-white text-lg">{item}</span>
                  </div>
                ))}
              </div>

              <div className="mt-12 p-6 bg-white/5 rounded-lg border border-white/20">
                <h3 className="text-white font-semibold text-xl mb-3">Danışmanlık Almak İster Misiniz?</h3>
                <p className="text-gray-300 mb-4">
                  {service.title} konusunda profesyonel hukuki danışmanlık almak için bizimle iletişime geçebilirsiniz.
                </p>
                <a
                  href="/iletisim"
                  className="inline-block bg-[#997938] hover:bg-[#8a6a2f] text-white font-semibold px-6 py-3 rounded-full transform hover:scale-105 transition-all duration-300"
                >
                  İletişime Geç
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;